import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getProjectPatterns } from "@/app/actions/project/get-patterns/action";
import { CallScopeFilter } from "@/app/types/call/CallScopeFilter";
import { UCallScope } from "@/app/utils/UCallScope";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectPatterns(projectId?: number, filter: CallScopeFilter = {}) {
  return useQuery({
    queryKey: [QueryKey.PROJECT_PATTERNS, projectId, ...UCallScope.queryKey(filter)],
    queryFn: () => {
      if (!projectId) return null;
      return getProjectPatterns(projectId, filter);
    },
    enabled: !!projectId,
    placeholderData: keepPreviousData,
    staleTime: Infinity,
  });
}
